export const categories = {
  Varzeshi: [
    'KoshtiVaVazneBardari',
    'SaiereHozeha',
    'FootballIran',
    'FootballJahan',
    'Razmi',
    'ToopVaTour',
  ],
  Siasi: [
    'EmamVaRahbari',
    'AhzabVaTashakolha',
    'AmniatiVaDefaee',
    'Dolat',
    'Majles',
    'TashakolhaieDaneshghai',
  ],
  Eghtesadi: [
    'EghtesadKalanVaBoodje',
    'TaavonVaEshteghal',
    'Boors',
    'BimeVaBank',
    'RahVaMaskan',
    'SanatTejaratBazargani',
    'KeshavarziVaOmooreDam',
    'NaftVaEnergy',
    'EghtesadeBinolmelal',
  ],
  ElmiVaDaneshghai: ['Amouzesh', 'ElamVaFanavariIran', 'ElamVaFanavariJahan'],
  Ejtemaee: [
    'Salamat',
    'AmouzeshVaParvaresh',
    'HoghoughiVaGhazaee',
    'EntezamiVaHavades',
    'MohitZistVaGardeshgari',
    'Shahri',
    'ZananVaJavanan',
    'RefahVaAsibhaieEjtemaee',
  ],
  Beinolmelal: [
    'AmricaVaEurope',
    'SharghAsiaVaOghianousie',
    'GharbAsia',
    'Africa',
  ],
  FarhangHonarVaResane: [
    'DiniVaMazhabi',
    'RadioVaTV',
    'CinemaVaTheatre',
    'MousighiVaHonarhaieTajasomi',
  ],
  Roozmare: ['Roozmare'],
};
